import { createFileRoute } from "@tanstack/react-router";
import { LogsPanel } from "@/features/observability/LogsPanel";

export const Route = createFileRoute(
  "/_app/o/$orgId/projects/$projectId/services/$serviceId/logs",
)({
  component: LogsScreen,
});

function LogsScreen() {
  const { orgId, projectId, serviceId } = Route.useParams();
  return <LogsPanel orgId={orgId} projectId={projectId} serviceId={serviceId} />;
}
